import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { iVariantResponse, iVariantResponseState } from 'store/types/assembler';

export const initialState: iVariantResponseState = {
  variantResponse: null,
};

export const variantSlice = createSlice({
  name: 'variantResponse',
  initialState,
  reducers: {
    setVariants: (state, action: PayloadAction<iVariantResponse>) => {
      // Replace the entire variant state
        const variantResult: iVariantResponse = action.payload
        state.variantResponse = variantResult
    },
        clearVariants: (state) => {
      state.variantResponse = null
    },
  }
});

// The exported reducer
export default variantSlice.reducer;
// Export the action
export const { setVariants, clearVariants } = variantSlice.actions;
// Optional selector
export const variantReducerState = (state: RootState) => state.variantResult;
